import { render, staticRenderFns } from "./BannersTodos.vue?vue&type=template&id=14395c6c&"
import script from "./BannersTodos.vue?vue&type=script&lang=js&"
export * from "./BannersTodos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports